<template>
  <loading-content
    class="md-primary"
    error
    error-icon="lock"
    error-label="Area restringida."
    :error-description="erroDescription"
  >
    <div class="md-group">
      <!-- <md-button class="md-round md-sm md-danger" -->
      <!-- v-if="$route.query.to" -->
      <!-- :to="{ -->
      <!-- path: $route.query.to, -->
      <!-- replace: true -->
      <!-- }" -->
      <!-- > -->
      <!-- <md-icon> refresh </md-icon> -->
      <!-- Reintentar -->
      <!-- </md-button> -->
      <md-button class="md-round md-sm md-warning" @click="$router.go(-1)">
        <md-icon> keyboard_arrow_left </md-icon>
        Atras
      </md-button>
    </div>
  </loading-content>
</template>

<script>

const formatURL = (url) =>
  `${url}: No tiene permiso `

export default {
  name: 'Error403',
  props: {
    description: {
      type: String,
      default: "No tiene permiso para acceder a esta pagina."
    },
    from: {
      type: String,
      default: null
    }
  },
  computed: {
    erroDescription() {
      const { $route: route, description, permissionInfo } = this

      const { from, description: routeDescription } = route.query

      return (from ? formatURL(from) : description) + permissionInfo + ` ${(routeDescription || '')}`
    },
    permissionInfo() {
      const { app, model, permission } = this.$route.query
      if (app && model) {
        return `${app}/${model}: ${permission}`
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Errors/403.vue